(() => {
function mountScrollLayers(root = document) {
  const nodes = Array.from(root.querySelectorAll('[data-depth]'));
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  const render = () => {
    frame = 0;
    const height = window.innerHeight;
    nodes.forEach(node => {
      const box = (node.closest('.hero-stage') || node).getBoundingClientRect();
      const travel = Math.max(-1, Math.min(1, (height / 2 - box.top - box.height / 2) / height));
      node.style.setProperty('--layer-y', preference.matches ? '0px' : `${travel * Number(node.dataset.depth || 0)}px`);
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(render); };
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule, {passive:true});
  preference.addEventListener('change', schedule);
  render();
  return () => {cancelAnimationFrame(frame);removeEventListener('scroll',schedule);removeEventListener('resize',schedule);preference.removeEventListener('change',schedule);nodes.forEach(n=>n.style.removeProperty('--layer-y'));};
}

let dispose=mountScrollLayers();document.addEventListener("shopify:section:load",()=>{dispose();dispose=mountScrollLayers();});document.addEventListener("shopify:section:unload",()=>{dispose();dispose=mountScrollLayers();});
})();